export const calculatePrice = (applyVAT = false) => {
	const DEFAULT_PRICE = 14.99;
	const VAT_RATE = 0.2;

	const totalPrice = applyVAT
		? DEFAULT_PRICE * (1 + VAT_RATE)
		: DEFAULT_PRICE;
	return parseFloat(totalPrice.toFixed(2));
};
